import React, { useEffect, useState, useRef } from "react";

import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CloudStorage from "../../CloudStorage/CloudStorage";
import { Field } from "formik";
import ContractView from "../CustomComponents/ContractView";

export default function PopupPrivacyPolicy({ setModal, setFieldValue }) {
  const path = "Assets/scss/postproject.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const handleScrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setFieldValue("agree", true);
        setModal(false);
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  return (
    <>
      <button onClick={() => setModal(false)} className="btn close-button">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <div className="popup-contract-container">
        <div className="scroll-to-bottom-container" style={{ textAlign: 'right', padding: '10px 20px 0' }}>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleScrollToBottom}
            style={{
              backgroundColor: '#ee7811',
              borderColor: '#ee7811',
              color: '#fff',
              borderRadius: '20px',
              padding: '6px 15px',
              fontSize: '12px',
              fontWeight: 'bold'
            }}
          >
            Scroll to Bottom
          </button>
        </div>
        <ModalBody>
          <div
            ref={scrollRef}
            style={{
              maxHeight: "60vh",
              overflowY: "auto",
              paddingRight: "10px",
              marginBottom: "20px"
            }}
          >
            <h1 className="font-42 text-center">Terms and Conditions </h1>
            <ContractView type={'general_terms'} />
            <div className="input-check">
              <input
                type="checkbox"
                onClick={() => {
                  setModal(false);
                  setFieldValue("agree", true);
                }}
                id="agree"
                name="agree"
              />
              <label htmlFor="agree">
                Yes, I understand and agree to Urxprt’s
                <span>{" "}Terms of Service</span>, including the
                <span>{" "}User Agreement</span> and <span>{" "}Privacy Policy</span>.
              </label>
            </div>
          </div>
        </ModalBody>
      </div>

    </>
  );
}
